import React from 'react';

export default () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='12'
        height='11.58'
        viewBox='0 0 12 11.58'
    >
        <path fill='inherit' d='M11.714.844L10.638.112a.653.653 0 00-.905.171L4.456 8.064 2.031 5.64a.651.651 0 00-.919 0l-.922.922a.654.654 0 000 .922l3.729 3.729a1.265 1.265 0 00.833.368 1 1 0 00.786-.464l6.351-9.369a.65.65 0 00-.175-.904z'/>
    </svg>
);
